<template>
    <div>
        <v-container>
            <v-card>        
                <v-card-text>
                    <v-row>
                        <v-col cols="3" class="yellow lighten-4 font-weight-bold">Peserta</v-col>              
                        <v-col>
                            <v-data-table :headers="headers" :items="listSppbj" hide-default-footer>

                                <!-- Status -->
                                <template v-slot:item.status="{item}">
                                    {{ getStatusVendor(item.status) }}
                                </template>

                                <!-- Tgl Kirim -->
                                <template v-slot:item.tglKirim="{item}">
                                    {{ getDateFormattedDatefns(item.tglKirim) }}
                                </template>

                                <!-- File Undangan -->
                                <template v-slot:item.fileSppbj="{item}">
                                    <v-file-input v-if="item.fileSppbj === ''"
                                        :placeholder="item.fileSppbj" 
                                        accept=".jpg,.png,.pdf,.doc,.docx,.xls,.xlsx,.zip" 
                                        @change="setUploadFile($event, item)"
                                    >
                                    </v-file-input>
                                    <v-btn v-else icon @click="tenderLib.getFileDownloadLink(paket.id, `FileSppbj_${item.vendorId}`, item.fileSppbj, false)"><v-icon color="green">get_app</v-icon></v-btn>
                                    {{ item.fileSppbj }}
                                </template>

                                <!-- Include -->
                                <template v-slot:item.include="{item}">
                                    <v-checkbox v-if="item.tglKirim == null || item.tglKirim === ''" v-model="item.include" />
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>            
                    <v-row>
                        <v-col cols="3" class="yellow lighten-4 font-weight-bold"></v-col>              
                        <v-col>
                            <v-btn v-if="!readonly && listSppbj.length > 0" color="green" dark @click="kirimSppbj()">Kirim Sppbj</v-btn>
                        </v-col>
                    </v-row>             
                    <v-row v-if="paket.metodePemilihan == 'TEN' || paket.metodePemilihan == 'SEL'">
                        <v-col class="text-right"> <v-btn  color="cyan" dark @click="showConfirmation = true">Tender Selesai</v-btn> </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-container>
        <v-dialog v-model="showConfirmation" max-width="500px" persistent>  
            <v-card dark>
                <v-card-title>Anda yakin ingin menyelesaikan proses tender?</v-card-title>
                <v-divider />
                <v-card-actions>
                    <v-btn color="success" dark @click="submitTenderSelesai()">Selesai</v-btn>
                    <v-btn color="orange" dark @click="showConfirmation = false">Batal</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Notification -->
        <v-snackbar
            v-model="notification.show"
            :color="notification.color"
            :timeout=3000
            top
        >
            {{notification.text}}
        </v-snackbar>

        <v-dialog v-model="submitting" persistent max-width="300px">
            <v-card dark>
                <v-card-title>Sedang diproses</v-card-title>
                <v-card-text> <v-progress-linear color="cyan" indeterminate /> </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>

<script>
const axios = require('axios').default;
const apiUrl = process.env.VUE_APP_ROOT_API
import { TenderLib } from "../../lib/tenderLib";
import { format, parseISO } from 'date-fns';

export default {
    props: {
        tipe: {
            type: String,
            default: 'B'
        },
        readonly: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            tenderLib: TenderLib,
            headers: [
                { text: "Nama", value: "nama", class: "teal lighten-4 font-weight-bold" },
                { text: "Status", value: "status", class: "teal lighten-4 font-weight-bold" },
                { text: "Tgl Kirim", value: "tglKirim", class: "teal lighten-4 font-weight-bold" },
                { text: "File", value: "fileSppbj", class: "teal lighten-4 font-weight-bold", width: "35%" },
                { text: "", value: "include", class: "teal lighten-4 font-weight-bold" },
            ],
            listSppbj: [],
            listUploadFile: [],

            notification: {
                show: false,
                color: "",
                text: ""
            },
            submitting: false,
            showConfirmation: false,
        }
    },
    computed: {
        userId: function() {
            return this.$store.getters['userInfo'].userId;
        },
        paket: function() {
            return this.$store.getters['lelang/paket']
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getListSppbj(listPeserta) {
            this.listSppbj = [];
            this.listUploadFile = [];
            if (listPeserta.length === 0) return;

            axios.get(`${apiUrl}/api/lelang/sppbj/${this.paket.id}`)
            .then( (response) => { 
                console.log('response')
                console.log(response)
                listPeserta.forEach(element => {
                    let item = {
                        vendorId: element.vendorId,
                        nama: element.nama,
                        status: element.status,
                        tglKirim: null,
                        pengirim: null,
                        include: false,
                        fileSppbj: "",
                    };
                    const found = response.data.find(sppbj => sppbj.vendorId === element.vendorId);
                    if (found) {
                        item.tglKirim = found.tglKirim;
                        item.pengirim = found.namaPengirim;
                        item.fileSppbj = found.fileSppbj;
                    }
                    this.listSppbj.push(item);
                });

                this.listUploadFile.length = this.listSppbj.length;
            }).catch( (error) => {
                console.error(error);
            });
        },
        getData() {
            axios.get(`${apiUrl}/api/rup/paket/pesertanama/${this.paket.id}`)
            .then( (response) => {
                this.getListSppbj(response.data);
            }).catch( (error) => {
                console.error(error);
            });
        },
        getDateFormattedDatefns: function(date) {
            return date ? format(parseISO(date), "dd MMM yyyy") : "";
        },
        getStatusVendor(status) {
            switch (status) {
                case 'N': return 'Baru';
                case 'V': return 'Verifikasi';
                case 'A': return 'Aktif';
                case 'I': return 'Non Aktif';
                case 'S': return 'Suspend';
                default: break;
            }

            return 'Baru';
        },
        setUploadFile(value, baPeserta) {
            const index = this.listSppbj.findIndex(check => check.vendorId === baPeserta.vendorId);

            if (index != -1) {
                this.listUploadFile[index] = value;
            }
        },
        async kirimSppbj() {
            let baCount = 0;

            for (let i = 0; i < this.listSppbj.length; ++i) {
                const ba = this.listSppbj[i];

                if (ba.include) {
                    if (this.listUploadFile[i] == null || this.listUploadFile[i] === "" || this.listUploadFile[i] == "undefined") {
                        this.notification = {
                            show: true,
                            color: "error",
                            text: `Harap masukkan file sppbj untuk rekanan [${ba.nama}]`
                        }
                        return;
                    }                  

                    baCount++;
                }
            }

            if (baCount === 0) {
                this.notification = {
                    show: true,
                    color: "error",
                    text: "Minimal 1 (satu) vendor dipilih untuk mengirim Sppbj"
                }

                return;
            }

            this.submitting = true;

            let fdata = new FormData();
            fdata.append("userId", this.userId);
            fdata.append("paketPenyediaId", this.paket.id);
            fdata.append("count", this.listSppbj.length);
            fdata.append("listSppbj", JSON.stringify(this.listSppbj));

            for (let i = 0; i < this.listSppbj.length; ++i) {
                fdata.append(`listUploadFile[${i}]`, this.listUploadFile[i]);
            }
            axios.post(`${apiUrl}/api/lelang/sppbj`, fdata, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then( () => {
                this.getData();

                this.notification = {
                    show: true,
                    color: "success",
                    text: "Sppbj telah dikirim"
                };
            })
            .catch( (error) => {
                console.error(error);
                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal mengirim Sppbj. [${error.message}]`
                };
            })
            .finally( () => {
                this.submitting = false;
            });

        },
        submitTenderSelesai() {
            axios.put(`${apiUrl}/api/rup/lelang/selesai/${this.paket.id}`)
            .then( () => {
                this.notification = {
                    show: true,
                    color: "success",
                    text: "Proses tender telah selesai"
                };

                this.showConfirmation = false;
            })
            .catch( (error) => {
                console.error(error);
                this.notification = {
                    show: true,
                    color: "error",
                    text: `Gagal update proses penyelesaian tender [${error.message}]`
                }
            });
        },
    }

}

</script>
